// extracted by css-extract-rspack-plugin
export default {"cls1":"ActiveState-cls1_t9u","cls2":"ActiveState-cls2_HMv ActiveState-cls1_t9u","isDisabled":"ActiveState-isDisabled_zXc"};